import { Link, useLocation, useParams } from "react-router-dom";
import React from "react";
import labels from "../nodes/Logic/helpers/labels";
import usedIn from "./usedIn";

export default function UsedInLink({ arg }) {
  const params = useParams();
  const location = useLocation();
  const usedInData = usedIn(arg);
  return (
    <div>
      {usedInData.length > 0 && (
        <div>
          Used in:
          <ul className="list-group ">
            {usedInData.map((el, index) => (
              <li className="list-group-item " key={index}>
                {el.workflow && (
                  <Link
                    to={`/library/logic/builder/${params.projectID}${
                      el.workflow.UUID ? `/workflow/${el.workflow.UUID}` : ``
                    }${
                      el.workflow.UUID && el.isConfiguration
                        ? `/configuration`
                        : ``
                    }${el.workflow.UUID && el.sendList ? `/send-list` : ``}${
                      el.eventListener?.EventType
                        ? `/event/${el.eventListener.EventType}`
                        : ``
                    }${
                      el.eventListener?.UUID
                        ? `/listener/${el.eventListener.UUID}`
                        : ``
                    }${el.action?.UUID ? `/action/${el.action?.UUID}` : ``}`}
                    state={{
                      nextPage: location.pathname,
                      searchType: "advanced",
                    }}
                  >
                    Workflow: {el.workflow.Label}
                    {el.eventListener
                      ? ` - Event: ${el.eventListener.EventType}`
                      : ``}
                    {el.eventHandler
                      ? ` - Listener: ${el.eventHandler.Label}`
                      : ``}
                    {el.action ? ` - Action: ${labels[el.action.Type]}` : ``}
                    {el.workflow.UUID && el.sendList ? ` - send-list` : ``}
                  </Link>
                )}
                {el.messageTemplate && (
                  <Link
                    to={`/library/logic/builder/${params.projectID}/message-template/${
                      el.messageTemplate.UUID
                    }${el.messageTemplate && el.sendList ? `/send-list` : ``}`}
                    state={{
                      nextPage: location.pathname,
                      searchType: "advanced",
                    }}
                  >
                    Message template: {el.messageTemplate?.Label}{" "}
                    {el.messageTemplate && el.sendList ? ` - send-list` : ``}
                  </Link>
                )}
                {el.contactSet && (
                  <Link
                    to={`/library/logic/builder/${params.projectID}/contact-set/${el.contactSet.UUID}`}
                    state={{ nextPage: location.pathname }}
                  >
                    Message template: {el.contactSet?.Label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
